/* eslint-disable jsx-a11y/img-redundant-alt */

import React from "react";
import { FaFire, FaShareAlt, FaComment, FaTrash } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { RiEditCircleFill } from "react-icons/ri";
import UserProfile from "../images/avatar-defaul-girls.jpg";
import { Link, useHistory } from "react-router-dom";
import { url, cloudinary_url, video_cloudinary_url } from "../utils/url";
import axios from "axios";
import Comments from "./Comments";
import UserContext from "../UserContext";
import ShowLikesModal from "./Modals/ShowLikesModal";
// skeleton loader
import Skeleton from "react-loading-skeleton";
import ShareModel from "./Modals/ShareModel";
import PostOptions from "./Modals/PostOptions";
import ImageViewer from "./ImageViewer";
import VideoPlayer from "./VideoPlayer";
import BoracayContainer from "./explode/BoracayContainer";

var fileExtension = function (url) {
  return (url = url.substr(1 + url.lastIndexOf("/")).split("?")[0])
    .split("#")[0]
    .substr(url.lastIndexOf("."));
};

export default function Posts({ data = {}, showFewComments = true }) {
  const {
    user,
    users,
    reloadRequests,
    mode,
    makeHommie,
    removeHommie,
    deletePost,
  } = React.useContext(UserContext);
  const [comments, setcomments] = React.useState([]);
  const [message, setmessage] = React.useState([]);
  const [lastuserToLike, setlastuserToLike] = React.useState({});
  const [reload, setreload] = React.useState(true);
  const [liked, setliked] = React.useState(data.liked || false);
  const [modalShow, setmodalShow] = React.useState(false);
  const [usersToShow, setUsersToShow] = React.useState([]);
  const [showShareModel, setshowShareModel] = React.useState(false);
  const [showPostOptions, setshowPostOptions] = React.useState(false);
  const [sendingRequest, setsendingRequest] = React.useState(null);
  const [showExplode, setshowExplode] = React.useState(false);
  const countStart = React.useRef(0);
  const history = useHistory();

  React.useEffect(() => {
    checkLiked();
    async function loadComments() {
      await axios
        .get(`${url}/api/posts/comments/getcomments/${data._id}`)
        .then((res) => {
          if (res.data?.data?.length > 0) {
            setcomments(res.data?.data);
          }
        });
    }
    loadComments();
    changeusersToShow();
    handlelastliked();
    // eslint-disable-next-line
  }, [data, users, reload]);

  const changeusersToShow = () => {
    const tempusers = data.arrayOfFires?.map((user) => {
      return users?.find((record) => record._id === user);
    });
    setUsersToShow(tempusers || []);
  };
  const handlelastliked = async () => {
    let tempArray = data.arrayOfFires?.reverse();
    if (tempArray?.length > 0) {
      let lastUser = tempArray[0];
      await axios
        .get(`${url}/api/auth/profile/${lastUser}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((res) => {
          setlastuserToLike(res.data.data);
        });
    }
  };

  const handlemessage = (e) => {
    setmessage(e.target.value);
  };
  const checkLiked = async () => {
    let myLike = data?.arrayOfFires?.find((item) => {
      return item === user.info?._id;
    });
    setliked(myLike ? true : false);
  };
  const sendmessage = async (e) => {
    e.preventDefault();
    let messageToSend = message;
    setmessage("");
    await axios
      .post(
        `${url}/api/posts/comments/addcomment/${data._id}`,
        {
          content: message,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      )
      .then((res) => {
        setreload(!reload);
      })
      .catch((err) => {
        setmessage(messageToSend);
        window.displayToastError(
          err.response?.data?.error || "Message not sent"
        );
      });
  };

  const clickLike = async () => {
    // if (user.token) {
    //   setliked(!liked);
    // }
    // if (!liked)
    setshowExplode(true);
    if (user.info?._id) {
      setliked(true);
      if (!data.arrayOfFires.includes(user.info._id)) {
        data.arrayOfFires.push(user.info._id);
      }
    }
    await axios
      .put(
        `${url}/api/posts/likepost/${data._id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      )
      .then((res) => {
        reloadRequests();
        setreload(!reload);
      })
      .catch((err) => {
        window.displayToastError(err.response.data.error || "Error occured");
      });
  };
  // setting the theme
  const [dark, setDark] = React.useState(false);

  // check the video or image data coming
  let dataFile;
  let filename;
  let fileExt;
  // check data.image ext. type
  if (data.image) {
    filename = data?.image;
    fileExt = fileExtension(filename).slice(1);
    if (
      fileExt === "mp4" ||
      fileExt === "mpg" ||
      fileExt === "mpeg" ||
      fileExt === "vob" ||
      fileExt === "avi" ||
      fileExt === "webm"
    ) {
      dataFile = "video";
    } else dataFile = "picture";
  }

  const image_file = data?.image?.startsWith("http")
    ? data?.image
    : cloudinary_url + data.image;
  const video_file = data?.image?.startsWith("http")
    ? data?.image
    : video_cloudinary_url + data.image;

  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  const clickHommy = async (id) => {
    if (!user.token) {
      window.Toast.fire({
        icon: "error",
        title: "You are not authorized to this service",
      });
      return;
    }
    setsendingRequest(id);
    let response = await makeHommie(id);
    setshowPostOptions(false);
    if (response.success && response.message) {
      window.Toast.fire({ icon: "success", title: response.message });
    }
    reloadRequests();
    setsendingRequest(null);
  };

  const clickRemoveHommy = async (id) => {
    setsendingRequest(id);
    let response = await removeHommie(id);
    setshowPostOptions(false);
    if (response.success && response.message) {
      window.Toast.fire({ icon: "success", title: response.message });
    }
    reloadRequests();
    setsendingRequest(null);
  };

  let hommie =
    user?.info?.followings?.includes(data.author?._id) &&
    data?.author?.hommies?.includes(user.info?._id);
  let img_url = data.author?.image
    ? data.author?.image
    : url + data.author?.profile?.url || UserProfile;

  countStart.current += 1;

  return (
    <div className="mt-4">
      <div className={dark ? "card darkmode divbg-in-darkmode" : "card"}>
        <div
          className={
            dark
              ? "card-header flex justify-between items-center darkmode divbg-in-darkmode"
              : "card-header flex justify-between items-center bg-white"
          }
        >
          <div
            className="flex justify-start items-center cursor-pointer gap-3 w-full"
            onClick={() => {
              history.push(`/users/${data.author?.username}`);
            }}
          >
            {data.author?.profile?.url ? (
              <div className="">
                <img
                  src={img_url}
                  alt={`${data.author?.username}'s profile`}
                  className="object-cover bg-gray-100"
                />
              </div>
            ) : (
              <div
                className="rounded-full"
                style={{ width: "50px", height: "45px" }}
              >
                {" "}
                <Skeleton circle={true} width={"100%"} height={"100%"} />
              </div>
            )}

            <div className="">
              {data.author?.username ? (
                <span className="font-bold flex gap-2 items-center">
                  {data.author?.username}
                  {data.author?.account_type === "VERIFIED" && (
                    <div title="Account verified">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                          d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
                          fill="rgba(249,2,2,1)"
                        />
                      </svg>
                    </div>
                  )}
                </span>
              ) : (
                <div className="w-full">
                  {" "}
                  <Skeleton width={"50%"} height={20} />
                </div>
              )}
            </div>
          </div>
          {!hommie && data.author?._id !== user.info?._id && (
            <button
              className="text-xs  font-mono italic hover:text-white hommy--btn rounded px-2 py-1 mr-3 hover:opacity-80 no-underline"
              disabled={sendingRequest === data.author?._id}
              onClick={() => clickHommy(data.author?._id)}
            >
              {sendingRequest === data.author?._id ? "Wait..." : "Hommy"}
            </button>
          )}
          <div className="dropdown">
            <button
              onClick={() => {
                setshowPostOptions(true);
              }}
            >
              <BsThreeDots />
            </button>
            <PostOptions
              show={showPostOptions}
              toCopyUrl={`${process.env.REACT_APP_BASE_FRONTEND_URL}/p/${data._id}`}
              onHide={() => {
                setshowPostOptions(false);
              }}
              data={data}
              hommie={hommie}
              addhommie={clickHommy}
              removehommie={clickRemoveHommy}
            />
          </div>
        </div>
        <div className="card-block">
          <div className="w-full h-1/2  feed--image flex justify-center all-container">
            {data.type === "ANONYTWIK" || (!data.image && data.gradient) ? (
              <>
                <div
                  className={`${data.gradient} w-full twik--anony-post text-white flex items-center justify-center text-2xl p-5`}
                >
                  <div className="break-all">{data.content}</div>
                </div>
              </>
            ) : (
              <div className="w-full">
                {data.image &&
                  (dataFile === "picture" ? (
                    // <img
                    //   src={cloudinary_url + data.image}
                    //   alt="Twika image"
                    //   className="object-fit"
                    // />
                    <ImageViewer
                      imageUrl={image_file}
                      imageAlt={data.author?.username}
                      imageType="post"
                      width={"100%"}
                      height={"100%"}
                      onDoubleClick={clickLike}
                    />
                  ) : (
                    <div style={{ width: "100%" }}>
                      {/* <video width="100%" height="500" controls>
                    <source src={video_cloudinary_url + data.image} />
                  </video> */}
                      <VideoPlayer
                        source={video_file}
                        width={"100%"}
                        style={{ height: "500px" }}
                        videoId={`vidId${Math.random()}`}
                        onDoubleClick={clickLike}
                      />
                    </div>
                  ))}
              </div>
            )}
          </div>

          {data.type !== "ANONYTWIK" &&  (data.image && data.gradient) && (
            <>
              {data.content ? (
                <div className="card-text block px-3 my-3 mb-2">
                  {data.content}
                </div>
              ) : (
                <div className="w-full  px-2 mb-2">
                  {" "}
                  {/* <Skeleton width={"90%"} height={20} /> */}
                </div>
              )}
            </>
          )}
        </div>
        {data.type === "ANONYTWIK" && (
          <div className="p-3">
            {data.user_id === user.info?._id && (
              <div className="right-aligned save">
                <i>
                  <Link to={`/edit-post/${data._id}`}>
                    <RiEditCircleFill title="Edit post" />
                  </Link>
                </i>
              </div>
            )}
          </div>
        )}
        {data.type !== "ANONYTWIK" && (
          <>
            {data._id ? (
              <div
                className={
                  dark
                    ? "p-2 text-muted flex justify-between items-center"
                    : "card-footer text-muted flex justify-between items-center"
                }
              >
                <div className="left-aligned flex">
                  <i
                    className={
                      !liked ? "fire relative " : " fire__active relative"
                    }
                    onClick={clickLike}
                  >
                    <FaFire></FaFire>
                    {showExplode && (
                      <BoracayContainer
                        onComplete={() => setshowExplode(false)}
                        count={countStart.current}
                      ></BoracayContainer>
                    )}
                  </i>
                  <i className="ml-2 comment">
                    <FaComment></FaComment>
                  </i>
                  <i className="ml-2 share">
                    <FaShareAlt onClick={() => setshowShareModel(true)} />
                    <ShareModel
                      toCopyUrl={`${process.env.REACT_APP_BASE_FRONTEND_URL}/p/${data._id}`}
                      postsText={data.content}
                      show={showShareModel}
                      onHide={() => {
                        setshowShareModel(false);
                      }}
                    />
                  </i>
                </div>
                {/* <FaSave></FaSave> */}
                {data.user_id === user.info?._id && (
                  <div className="right-aligned save flex gap-4">
                    <i>
                      <Link to={`/edit-post/${data._id}`}>
                        <RiEditCircleFill title="Edit post" />
                      </Link>
                    </i>
                    <i>
                      <FaTrash
                        title="Delete post"
                        onClick={() => deletePost(data._id)}
                        style={{ color: "red" }}
                      />
                    </i>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex gap-3 ml-2">
                <Skeleton width={30} height={30} circle={true} />
                <Skeleton width={30} height={30} circle={true} />
                <Skeleton width={30} height={30} circle={true} />
              </div>
            )}
          </>
        )}

        {/* check if fires are available */}
        {data.arrayOfFires?.length !== 0 && (
          <div
            className={
              dark
                ? "card-footer2 text-muted px-3"
                : "card-footer card-footer2 text-muted"
            }
          >
            {data.arrayOfFires?.length > 0 ? (
              <div className="flex justify-start items-center w-full">
                {/* <img
                  src={
                    liked
                      ? `${url}${user.info?.profile?.url}`
                      : `${url}${lastuserToLike.profile?.url}` || UserProfile
                  }
                  alt="Commented user"
                  className="comment-profile"
                /> */}
                <div className="w-6 h-6">
                  <ImageViewer
                    imageUrl={
                      liked
                        ? `${
                            user.info?.image
                              ? user.info?.image
                              : url + user.info?.profile?.url
                          }`
                        : `${
                            lastuserToLike?.image
                              ? lastuserToLike?.image
                              : url + lastuserToLike.profile?.url || UserProfile
                          }`
                    }
                    width={0}
                    height={0}
                    imageAlt={
                      liked
                        ? user.info.username
                        : lastuserToLike.username + "' Profile"
                    }
                  />
                </div>
                <p className="">
                  Fired by{" "}
                  <Link
                    to={
                      liked
                        ? `/users/${user.info?._id}`
                        : `/users/${lastuserToLike._id}`
                    }
                  >
                    {liked ? user.info.username : lastuserToLike.username}
                  </Link>{" "}
                  {data.arrayOfFires?.length > 1 && (
                    <span
                      className="c-pointer"
                      onClick={() => {
                        setmodalShow(true);
                      }}
                    >{`and ${data.arrayOfFires?.length - 1 || 0} 
                ${
                  data.arrayOfFires?.length - 1 === 1 ? "other" : "others"
                }`}</span>
                  )}
                  <ShowLikesModal
                    show={modalShow}
                    onHide={() => {
                      setmodalShow(false);
                    }}
                    fires={data.arrayOfFires}
                    users={usersToShow}
                    user={user}
                    sendingRequest={sendingRequest}
                    addhommie={clickHommy}
                    removehommie={clickRemoveHommy}
                  ></ShowLikesModal>
                  <br />
                  <small>
                    {new Date(parseInt(data.postedAt)).toUTCString()}
                  </small>
                </p>
              </div>
            ) : (
              <p>No fires</p>
            )}
          </div>
        )}
        <div className={dark ? "px-3 " : ""}>
          {data.type !== "ANONYTWIK" && (
            <Comments
              data={comments}
              post={data}
              showFew={showFewComments}
            ></Comments>
          )}
        </div>
        <form
          className={
            dark
              ? "card-footer-dark card-footer3 text-muted divbg-in-darkmode"
              : "card-footer card-footer3 text-muted"
          }
          onSubmit={sendmessage}
        >
          <input
            type="text"
            value={message}
            className={dark ? "darkmode" : ""}
            onChange={handlemessage}
            placeholder={`${
              data.type === "ANONYTWIK"
                ? "Reply anonymously ... 🔥"
                : 'Leave a comment 🔥 ...'
            }`}
          />
        </form>
      </div>
    </div>
  );
}